import '../assets/css/src/footer.css';
import { siteName, tagline, email, social } from '../config/site.js';

export default function Footer() {
  return (
    <footer id="footer">
      <p className="footer-tagline">{tagline}</p>
      <ul>
          {social.map(({ label, url }) => (
            <li key={label}>
              <a href={url} target="_blank" rel="noreferrer">{label}</a>
            </li>
          ))}
      </ul>
          <a href={`mailto:${email}`}>{email}</a>
      <p>&copy; {new Date().getFullYear()} {siteName}. All rights reserved.</p>
    </footer>
  );
}
